(function ($) {
  $(function () {
    var $productCardGrid = $(".products-card-grid");
    var $header = $("header");
    var $stickyNav = $(".sticky-nav");

    if ($productCardGrid.length) {
      var productCardGrid = (function () {
        var hash;
        function storeHashAndRemoveHashFromUrl() {
          // Store the hash value and then remove it from the URL
          hash = window.location.hash;
  
          if (hash.length) {
            history.replaceState({}, document.title, window.location.pathname);
          }
        }

        function getMainNavHeight() {
          return $header.find(".main-nav").outerHeight();
        }

        function getStickyNavHeight() {
          return $stickyNav.length ? $stickyNav.outerHeight() : 0;
        }

        function getAnchorOffsetTop(anchor) {
          var $anchor = $(anchor);

          if ($anchor.length) {
            return $anchor.offset().top;
          }
        }

        function smoothScrollTo(el) {
          var currentScrollPos = $(window).scrollTop();
          var anchorOffsetTop = getAnchorOffsetTop(el);
          var scrollTopPos = anchorOffsetTop - (getStickyNavHeight() + getMainNavHeight() + 1);

          if (currentScrollPos < anchorOffsetTop) {
            if ($(window).width() > 1023) {
              scrollTopPos = anchorOffsetTop - (getStickyNavHeight() + 1);
            } 
          }

          $("html, body").animate(
            {
              scrollTop: scrollTopPos,
            },
            700, function () {
              if (hash.length) {
                history.pushState({}, document.title, hash);
              }
            }
          );
        }

        function smoothScrollOnHash() {
          if (hash.length) {
            smoothScrollTo(hash);
          }
        }

        return {
          inIt: function () {
            storeHashAndRemoveHashFromUrl();
          },
          load: function () {
            smoothScrollOnHash();
          },
        };
      })();

      productCardGrid.inIt();

      $(window).on("load", productCardGrid.load);
    }
  });
})(jQuery);
